import React from 'react';
import './App.css';

export default function About() {
  return (
    <main className="about-page">
      <div className="about-inner">
        <h2 className="about-title">Mdoukha (مذوخا)</h2>
        <p className="about-text">Mdoukha (مذوخا) is a village and municipality 72 kilometres (45 mi) east of Beirut in the Rashaya District, Beqaa Governorate, Lebanon. A significant majority of the population is considered to be Lebanese Canadian, with 60% living in London, Ontario.</p>
      </div>
    </main>
  );
}
